import { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import '../../assets/css/vendors/HotelComponents/vendorLayout.css';
import HotelHeader from '../../components/vendors/HotelHeader';
import HotelSidebar from '../../components/vendors/HotelSidebar';
import AppContext from '../../context/AppContext';

const VendorLayout = ({ children }) => {
  const { setAuthToken, isCollapsed, setIsCollapsed, toggleCollapsed } = useContext(AppContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 991);

  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    setAuthToken(authToken);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 991;
      setIsMobile(mobile);
      if (!mobile) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
        setIsCollapsed(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    if (isMobile) {
      setIsSidebarOpen(prev => !prev);
    } else {
      toggleCollapsed();
    }
  };

  const closeSidebar = () => {
    if (isMobile) setIsSidebarOpen(false);
  };

  return (
    <div className="vhotel-dashboard">
      <HotelSidebar
        isMobile={isMobile}
        isSidebarOpen={isSidebarOpen}
        isCollapsed={isCollapsed}
        onClose={closeSidebar}
        onToggle={toggleSidebar}
      />

      <div
        className={`vhotel-main-content 
          ${!isMobile && isCollapsed ? 'vhotel-collapsed-content' : ''} 
          ${isMobile ? 'vhotel-mobile-view' : ''}`}
      >
        <HotelHeader
          isMobile={isMobile}
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={toggleSidebar}
          isCollapsed={isCollapsed}
        />

        <div className="vhotel-page-body">
          <Container fluid>
            <div className="vhotel-dashboard-grid">
              {children}
            </div>
          </Container>
        </div>
      </div>

      {isMobile && isSidebarOpen && (
        <div className="vhotel-sidebar-overlay" onClick={closeSidebar} />
      )}
    </div>
  );
};

export default VendorLayout;